/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : UI 관련 스토어
 * 버전 : 1.0
 * 파일명 : UIStore.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2025-07-14, 강동형 : 저작권 추가, DeferredPRompt 전역변수 추가
 * ================================================================
 */

import { create } from 'zustand';

interface NavbarState {
    isvisible : boolean
    isSideBarOpen : boolean
    setField : (field: keyof NavbarState, value: any) => void 
}

export const useNavbarStore = create<NavbarState>((set)=>({
    isvisible : true,
    isSideBarOpen : false,
    setField: (field,value)=>set((state)=>({...state,[field]:value})),
}))

type BackHandlerStore = {
    isPopUp: boolean
    setisPopUp : (value:boolean)=>void;
    customAction: any;
    setCustomAction: (action: any) => void;
  };
  
export const useBackHandlerStore = create<BackHandlerStore>((set) => ({
  isPopUp: false,
  setisPopUp :(value: boolean) => set({ isPopUp: value }),
  customAction: '',
  setCustomAction: (action: any) => set({ customAction: action }),
}));

interface PwaStore {
  deferredPrompt: any | null;
  setDeferredPrompt: (prompt: any) => void;
  clearDeferredPrompt: () => void;
  whichDevice : string
  setWhichDevice : (device: string)=>void;
  isInsatalled : boolean;
  setIsInsatalled : (check: boolean)=>void;
}

export const usePwaStore = create<PwaStore>((set) => ({
  deferredPrompt: null,
  setDeferredPrompt: (prompt) => set({ deferredPrompt: prompt }),
  clearDeferredPrompt: () => set({ deferredPrompt: null }),
  whichDevice : 'etc',
  setWhichDevice : (device)=> set({ whichDevice : device}),
  isInsatalled: false,
  setIsInsatalled : (check)=> set({ isInsatalled : check}),
}));